module.exports = __webpack_public_path__ + "assets/img/de621997735958117066a7571adc0d02.png";